//Home.js
import { useState } from "react";
import Navbar from "../components/MainNavbar";

// Require Editor CSS files.
import "froala-editor/css/froala_style.min.css";
import "froala-editor/css/froala_editor.pkgd.min.css";

import FroalaEditorComponent from "react-froala-wysiwyg";
import SongsNavbar from "../components/SongsNavBar";

import { TSongSheet } from "../types/SongSheet";
import { CreateSongSheet } from "../services/SongSheet";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSave, faWineBottle } from "@fortawesome/free-solid-svg-icons";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import TagInput from "../components/TagInput";
import React from "react";
import { Tag } from "react-tag-input/types/components/SingleTag";

// const getBaseUrl = () => {
//   const currentUrl = new URL(window.location.href);
//   const baseUrl = currentUrl.protocol + "//" + currentUrl.host;

//   return baseUrl;
// }

const CreateSongSheetPage = () => {
  const [id, setSongId] = useState("");
  const [songName, setSongName] = useState("");
  const [artist, setArtist] = useState("");
  const [lyrics, setLyrics] = useState("");
  const [chords, setChords] = useState("");
  const [songType, setSongType] = useState("Cover");
  const [capo, setCapo] = useState("");
  const [defaultFontSize, setDefaultFontSize] = useState(16);
  const [tags, setTags] = React.useState<Array<Tag>>([]);
  const [folder, setFolder] = useState("");

  const navigate = useNavigate();

  const handleUpdateTags = (tags: any) => {
    console.log("*** tags updated ***", tags);
    setTags(tags);
  };

  const addSongSheet = () => {
    const newSong: TSongSheet = {
      name: songName,
      capo: capo,
      artist: artist,
      lyrics: lyrics,
      chords: chords,
      songType: songType,
      defaultFontSize: defaultFontSize,
      tags: tags,
      folder: folder,
    };

    CreateSongSheet(
      newSong,
      (res: any) => {
        toast.success("The new song sheet was created!");
        navigate(`/songs/edit/${res.data.insertedId}`);
      },
      (err: any) => {
        console.log(err);
        toast.error("An error occured creating the new song sheet");
      }
    );
  };

  const handleSubmit = (e: any) => {
    addSongSheet();
    e.preventDefault();
  };

  return (
    <div>
      <Navbar />
      <SongsNavbar />
      <div className="mainContainer">
        <h1>
          <FontAwesomeIcon icon={faWineBottle} />
          Create Song Sheet
        </h1>

        <form
          onSubmit={(e) => {
            handleSubmit(e);
          }}
        >
          <div className="two-columns-container">
            <div className="column-left">
              <span className="form-field">
                <label htmlFor="lname">Song Name</label>
                <input
                  id="songname"
                  type="text"
                  placeholder="Song Name"
                  value={songName}
                  onChange={(e) => setSongName(e.target.value)}
                />
              </span>
              <br />

              <span className="form-field">
                <label htmlFor="lname">Artist/Band</label>
                <input
                  type="text"
                  placeholder="Artist/Band"
                  value={artist}
                  onChange={(e) => setArtist(e.target.value)}
                />
              </span>
              <br />

              <span className="form-field">
                <label htmlFor="lname">Capo</label>
                <input
                  type="text"
                  placeholder="Capo Number"
                  value={capo}
                  onChange={(e) => setCapo(e.target.value)}
                />
              </span>
              <br />

              <span className="form-field">
                <label htmlFor="lname">Chords</label>
                <FroalaEditorComponent
                  config={{
                    height: 50,
                    toolbarInline: true,
                  }}
                  tag="textarea"
                  model={chords}
                  onModelChange={(event: any) => {
                    setChords(event);
                  }}
                />
              </span>
              <br />
              <span className="form-field">
                <label htmlFor="lname">Tags</label>
                <TagInput
                  initialTags={tags}
                  onHandleUpdateTags={handleUpdateTags}
                />
              </span>
              <br />
            </div>
            <div className="column-right">
              <span className="form-field">
                <label htmlFor="lname">Song Type</label>
                <input
                  type="text"
                  placeholder="Song Type"
                  value={songType}
                  onChange={(e) => setSongType(e.target.value)}
                />
              </span>
              <br />

              <span className="form-field">
                <label htmlFor="lname">Font Size</label>
                <input
                  type="text"
                  placeholder="Font size"
                  value={defaultFontSize}
                  onChange={(e) => setDefaultFontSize(Number(e.target.value))}
                />
              </span>
              <br />
            </div>
          </div>

          <FroalaEditorComponent
            config={{
              height: 800,
            }}
            tag="textarea"
            onModelChange={(event: any) => {
              setLyrics(event);
            }}
          />

          <button type="submit" className="btn">
            <FontAwesomeIcon icon={faSave} /> Save
          </button>
        </form>
      </div>
    </div>
  );
};

export default CreateSongSheetPage;
